import * as React from 'react';
import { useContext } from 'react';
import userContext from '../../Context/UserContext';
import { Container } from './styles';
import Carrossel from '../Carrossel';

const Vitrine: React.FC = () => {
  const currentlyUser = useContext(userContext);
  const { Codcliente, Codempresacli } = currentlyUser.user;

  return (
    <Container>
      <Carrossel Titulo={"Lançamentos"} Lancamento={1} Codcliente={Codcliente} Codempresacli={Codempresacli} />
      <Carrossel Titulo={"Mais Vendidos"} MaisVendidos={1} Codcliente={Codcliente} Codempresacli={Codempresacli} />
      <Carrossel Titulo={"Pré Venda"} PreVenda={1} Codcliente={Codcliente} Codempresacli={Codempresacli} />
    </Container>
  )
};

export default Vitrine;
